import { render, staticRenderFns } from "./SysNcConfigManagerDefault.vue?vue&type=template&id=b3d5d430&scoped=true&"
import script from "./SysNcConfigManagerDefault.vue?vue&type=script&lang=js&"
export * from "./SysNcConfigManagerDefault.vue?vue&type=script&lang=js&"
import style0 from "./SysNcConfigManagerDefault.vue?vue&type=style&index=0&id=b3d5d430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d5d430",
  null
  
)

export default component.exports